import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    margin: auto;
    background-color: #FFEFE8;
`;

const StyledH1 = styled.h1`
  background-color: #637E76;
  color: #FFEFE8;
  padding: 2vw;
`;

const StyledH3 = styled.h3`
  padding: 2vw;
  color: #C69774;
`;

const StyledH5 = styled.h5` 
    padding: 2vw;

`


export default function RenderComponent(props){
    return(
        <StyledDiv key = {props.objectID}>
            <StyledH1>Title: {props.title}</StyledH1>
            <StyledH3>Medium: {props.medium}</StyledH3>
            <StyledH3>Period: {props.period}</StyledH3>
            <StyledH3>Artist: {props.artistDisplayName}</StyledH3>
            <StyledH5>Accession Year: {props.accessionYear}</StyledH5>
            <StyledH5>Department: {props.department}</StyledH5>
            <StyledH5>Culture: {props.culture}</StyledH5>
            <img src= {props.primaryImageSmall} alt="object"/>
        </StyledDiv>
    );
}
